import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Input, Spinner, Table } from "../../../Components/ui";
import { AlimTalkWalletEntry, notificationCenterService } from "../../../api/services/notification-center.service";
import { ListDateFilters, ListPagination } from "./NotificationListControls";

const labels: Record<string, string> = { TOPUP_CREDIT: "충전", RESERVE: "발송금 예약", CAPTURE: "확정 차감", RELEASE: "예약 복원", ADJUSTMENT: "수동 조정" };

export default function AlimTalkLedger({ refreshKey = 0 }: { refreshKey?: number }) {
  const [query, setQuery] = useState({ page: 1, created_from: "", created_to: "", entry_type: "" });
  const [rows, setRows] = useState<AlimTalkWalletEntry[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(""); setRows([]);
    void notificationCenterService.getAlimTalkWalletEntries({ ...query, page_size: 20 }).then(({ data }) => {
      if (!active) return;
      setRows(data.results); setCount(data.count);
    }).catch(() => { if (active) setError("충전금 원장을 불러오지 못했습니다."); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [query, reload, refreshKey]);
  return <section className="border rounded p-3 mt-4" aria-label="충전금 원장">
    <h5>충전금 원장</h5>
    <div className="d-flex flex-wrap gap-2 mb-3">
      <Input aria-label="원장 유형" type="select" value={query.entry_type} onChange={(event) => setQuery({ ...query, page: 1, entry_type: event.target.value })} style={{ maxWidth: 180 }}>
        <option value="">전체 유형</option>{Object.entries(labels).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </Input>
      <ListDateFilters from={query.created_from} to={query.created_to} onChange={(created_from, created_to) => setQuery({ ...query, page: 1, created_from, created_to })} />
      <Button color="light" onClick={() => setReload(reload + 1)} disabled={loading}>새로고침</Button>
    </div>
    {error ? <Alert color="warning">{error}</Alert> : null}
    <div className="table-responsive"><Table className="small align-middle">
      <thead><tr><th>일시 / 유형</th><th>사용 가능 증감</th><th>발송 예약 증감</th><th>처리 후 잔액</th><th>관련 내역</th><th>사유</th></tr></thead>
      <tbody>
        {loading ? <tr><td colSpan={6}><Spinner size="sm" /></td></tr> : null}
        {!loading && !error && !rows.length ? <tr><td colSpan={6}>조회된 원장이 없습니다.</td></tr> : null}
        {rows.map((entry) => <tr key={entry.id}>
          <td>{new Date(entry.created_at).toLocaleString("ko-KR")}<br />{labels[entry.entry_type] || entry.entry_type} · 원장 #{entry.id}</td>
          <td>{entry.available_delta.toLocaleString()}원</td><td>{entry.reserved_delta.toLocaleString()}원</td>
          <td>사용 가능 {entry.available_after.toLocaleString()}원<br />예약 {entry.reserved_after.toLocaleString()}원</td>
          <td>{entry.topup_request_id ? <div>충전 요청 #{entry.topup_request_id}</div> : null}{entry.charge_id ? <div>차감 #{entry.charge_id}</div> : null}{entry.message_id ? <div>메시지 #{entry.message_id}</div> : null}{entry.notification_id ? <Link to={`/notification-center/history?notification_id=${entry.notification_id}`}>발송 #{entry.notification_id}</Link> : null}</td>
          <td>{entry.reason || "-"}</td>
        </tr>)}
      </tbody>
    </Table></div>
    <ListPagination label="원장" page={query.page} count={count} loading={loading} onChange={(page) => setQuery({ ...query, page })} />
  </section>;
}
